import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../../quote.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcessProtectService } from '../../excess.service';

@Component({
  selector: 'app-excess-protect-quote-view',
  templateUrl: './excess-protect-quote-view.component.html',
  styleUrls: ['./excess-protect-quote-view.component.css']
})
export class ExcessProtectQuoteViewComponent implements OnInit {
  id = this.route.snapshot.params.quote_id;
  selectedIndex = 0;
  isAdmin = false;
  isStaff = false;
  isBroker = false;
  hideForBroker = false;
  disablIfPastDate: boolean = false;
  constructor(private expService: ExcessProtectService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private quoteService: QuoteService, private sessionSt: LocalStorageService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }

    // if (this.sessionSt.retrieve('is_broker')) {
    //   this.selectedIndex = 1;
    // }

    this.getQuote();
    console.log(this.quoteDetails);
  }
  // GET QUOTE DETAILS
  quoteDetails: any = {};
  fullQuote;
  getQuote() {
    this.expService.getQuoteDetails(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {

        let res_quote = response.result.quote_data.quote_versions.filter(x => x.id == this.route.snapshot.params.quote_id);
           let quoteData = res_quote[0];

          this.quoteDetails = quoteData;
          this.quoteDetails.id = quoteData.id;
          this.quoteDetails.insurance_status_id = quoteData.insurance_status_id;
          this.quoteDetails.company_id = quoteData.company_id;
          this.quoteDetails.company_name = quoteData.policy_holder.company_name;
          this.quoteDetails.is_send_email = quoteData.is_send_email;
          this.quoteDetails.type = quoteData.type;
          this.quoteDetails.broker_id = quoteData.broker_id;
          this.quoteDetails.notes = quoteData.notes;
          if (quoteData.financial_details) {
            this.quoteDetails.peliwica_fee = quoteData.financial_details.fees;
            this.quoteDetails.broker_commission = quoteData.financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = quoteData.financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }

          this.quoteDetails.email = quoteData.policy_holder?.email;
          this.quoteDetails.phone = quoteData.policy_holder?.phone;
          this.quoteDetails.is_email = quoteData.policy_holder?.is_email;
          this.quoteDetails.is_phone = quoteData.policy_holder?.is_phone;
          this.quoteDetails.sms = quoteData.policy_holder?.sms;
          this.quoteDetails.post = quoteData.policy_holder?.post;
          this.quoteDetails.affinity_partner = quoteData.affinity_partner;
          this.quoteDetails.transactional_date = quoteData.transactional_date;
          this.fullQuote = quoteData;
          this.quoteDetails.is_paid = quoteData.is_paid;
          this.quoteDetails.product_id = quoteData.product_id;
          this.quoteDetails.is_policy = quoteData.is_policy;

          let policy_start_date = new Date(quoteData.policy_start_date);
          policy_start_date.setHours(0, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);
          if (policy_start_date.getTime() < today.getTime() && this.sessionSt.retrieve('company_role') == 'Broker') {
            this.hideForBroker = true;
          }
          // this.quoteDetails = response.result.quote_data.quote_versions[0];
          // this.quoteDetails.id = response.result.quote_data.quote_versions[0].id;
          // this.quoteDetails.insurance_status_id = response.result.quote_data.quote_versions[0].insurance_status_id;
          // this.quoteDetails.company_id = response.result.quote_data.quote_versions[0].company_id;
          // this.quoteDetails.company_name = response.result.quote_data.quote_versions[0].policy_holder.company_name;
          // this.quoteDetails.is_send_email = response.result.quote_data.quote_versions[0].is_send_email;
          // this.quoteDetails.type = response.result.quote_data.quote_versions[0].type;
          // this.quoteDetails.broker_id = response.result.quote_data.quote_versions[0].broker_id;
          // this.quoteDetails.notes = response.result.quote_data.quote_versions[0].notes;
          // if (response.result.quote_data.quote_versions[0].financial_details) {
          //   this.quoteDetails.peliwica_fee = response.result.quote_data.quote_versions[0].financial_details.fees;
          //   this.quoteDetails.broker_commission = response.result.quote_data.quote_versions[0].financial_details.broker_commission;
          //   this.quoteDetails.broker_admin_fee = response.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
          // } else {
          //   this.quoteDetails.peliwica_fee = 0;
          //   this.quoteDetails.broker_commission = 0;
          //   this.quoteDetails.broker_admin_fee = 0;
          // }

          // this.quoteDetails.email = response.result.quote_data.quote_versions[0].policy_holder?.email;
          // this.quoteDetails.phone = response.result.quote_data.quote_versions[0].policy_holder?.phone;
          // this.quoteDetails.is_email = response.result.quote_data.quote_versions[0].policy_holder?.is_email;
          // this.quoteDetails.is_phone = response.result.quote_data.quote_versions[0].policy_holder?.is_phone;
          // this.quoteDetails.sms = response.result.quote_data.quote_versions[0].policy_holder?.sms;
          // this.quoteDetails.post = response.result.quote_data.quote_versions[0].policy_holder?.post;
          // this.quoteDetails.affinity_partner = response.result.quote_data.quote_versions[0].affinity_partner;
          // this.quoteDetails.transactional_date = response.result.quote_data.quote_versions[0].transactional_date;
          // this.fullQuote = response.result.quote_data.quote_versions[0];
          // this.quoteDetails.is_paid = response.result.quote_data.quote_versions[0].is_paid;
          // this.quoteDetails.product_id = response.result.quote_data.quote_versions[0].product_id;
          // this.quoteDetails.is_policy = response.result.quote_data.quote_versions[0].is_policy;
          //this.getQuoteNotes();
        },
        (error) => {
          ;
        }
      );
  }
  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() {
    this.displayNewEmailView = true;
  }

  email_id: string = '';
  getEmailView(email_id) {
    this.email_id = email_id;
    this.displayEmailView = true;
  }
  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }
  // Issue Quote
  issueQuotePopup(issueQuoteModal) {
    this.disablIfPastDate = false;

    let policy_start_date = new Date(this.quoteDetails.policy_start_date);
    policy_start_date.setHours(0, 0, 0, 0);
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    if (policy_start_date.getTime() < today.getTime()) {
      this.disablIfPastDate = true;
    }

    this.modalService.open(issueQuoteModal, { centered: true });
  }

  issueQuote() {
    let data = {
      "quote_id": this.route.snapshot.params.quote_id
    };

    this.expService.issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.dismissAll();
            let id = this.route.snapshot.params.quote_id;
            this.router.navigateByUrl("/excess-protect/policy/" + id);
          };
        });
  }
}
